import React, { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  children: ReactNode;
}

function PillMenuItemIcon({ children }: Props) {
  return (
    <div className={classNames('h-[20px] w-[20px]', styles.pillMenuItemIcon)}>
      {children}
    </div>
  );
}

export default PillMenuItemIcon;
